export default __webpack_public_path__ + "static/media/46.55b98ece.png";